exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-container[data-v-1cd2d9b0]{max-height:21vw}", ""]);

// exports
